import { DEFAULT_BREAKPOINT, useBreakpointValue } from '@hub/design-system-base';

const useMobileBreakpoint = () => {
  var _useBreakpointValue;

  return (_useBreakpointValue = useBreakpointValue([true, true, false], DEFAULT_BREAKPOINT)) !== null && _useBreakpointValue !== void 0 ? _useBreakpointValue : false;
};

export default useMobileBreakpoint;